module.exports = __webpack_public_path__ + "img/4.e52a65f1.png";